import { FC } from "react";

import Container from "@components/Container";
import Skeleton from "@components/Skeleton";
import Spacer from "@components/Spacer";

const ProductPageSkeleton: FC = () => {
  return (
    <Container>
      <Spacer size="md" />
      <div className="product">
        <Skeleton height="380px" />
        <div className="skeleton-product-details">
          <Skeleton height="30px" width="200px" />
          <Skeleton height="30px" />
          <Skeleton height="17px" lines={14} />
          <Skeleton height="30px" width="150px" />
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .product {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 40px;
          }
        `}
      </style>
    </Container>
  );
};

export default ProductPageSkeleton;
